import React from 'react';

interface MultilineTextProps {
  text: string;
}

/** '\n' を <br /> に変換して描画する */
const MultilineText: React.FC<MultilineTextProps> = ({ text }) => {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

export default MultilineText;
